import { useMemo } from 'react';
import useIsPaidPortal from '../../../hooks/useIsPaidPortal';
import { useIsUngated } from '../../../hooks/useIsUngated';
import { useExperiments, useUser } from '../../../hooks/useNavConfig';
import { getExperimentGroup } from '../../../laboratory';
import { GROW_GUIDE_USER_GUIDE_EXPERIMENT_KEY } from '../constants/experiments';
import { GROW_GUIDE_USER_GUIDE_EXPERIMENT_GATE } from '../constants/gates';

// Hook to identify eligible users for the Growth Guide User Guide experiment
// Eligibility criteria: Free portal, enrolled in onboarding, new portal (via Gate Fulcrum)
export const useGrowGuideUserGuideExperiment = () => {
  const isUngatedForExperiment = useIsUngated(GROW_GUIDE_USER_GUIDE_EXPERIMENT_GATE);
  const {
    enrolledInUserGuide
  } = useUser();
  const {
    isPaidPortal,
    isPaidLoaded
  } = useIsPaidPortal();
  const isEnrolledInOnboarding = Boolean(enrolledInUserGuide);
  const isFreePortal = isPaidLoaded && !isPaidPortal;
  const experiments = useExperiments();
  const experimentGroup = getExperimentGroup(GROW_GUIDE_USER_GUIDE_EXPERIMENT_KEY, experiments);
  return useMemo(() => {
    const isEligible = isUngatedForExperiment && isEnrolledInOnboarding && isFreePortal;
    const isVariant = experimentGroup === 'variation';
    return {
      isEligibleForExperiment: isEligible,
      isEligibilityLoading: !isPaidLoaded,
      isVariant
    };
  }, [isUngatedForExperiment, isEnrolledInOnboarding, isFreePortal, isPaidLoaded, experimentGroup]);
};